import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTabs } from "../../../../../components";
import { useAuth } from "../../../../../context/AuthContext";
import { AgentBonus, Deposit, FirstDeposit, Withdraw } from "./components";

const FinancialDetailReport = ({ date = null }) => {
  const { t } = useTranslation();
  const { rebateMode } = useAuth();
  const [activeTab, setActiveTab] = useState("deposit");
  const tabItems = [
    {
      key: "deposit",
      title: t("financialReport.tab.deposit"),
      component: <Deposit date={date} type={"deposit"} rebateMode={rebateMode} />,
      destroyOnClose: true,
    },
    {
      key: "firstDeposit",
      title: t("financialReport.tab.firstDeposit"),
      component: <FirstDeposit date={date} type="firstDeposit" rebateMode={rebateMode} />,
      destroyOnClose: true,
    },
    {
      key: "withdraw",
      title: t("financialReport.tab.withdraw"),
      component: <Withdraw date={date} type="withdraw" rebateMode={rebateMode} />,
      destroyOnClose: true,
    },
    {
      key: "bonus",
      title: t("financialReport.tab.bonus"),
      component: <AgentBonus date={date} type="bonus" rebateMode={rebateMode} />,
      destroyOnClose: true,
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <CustomTabs activeKey={activeTab} onTabChange={onTabChange} tabItems={tabItems} />
    </div>
  );
};

export default FinancialDetailReport;
